module.exports = __webpack_public_path__ + "static/media/post1.9aea0a2c.jpeg";